function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

//
import React from 'react';

var DecorativeImage = function DecorativeImage(_ref) {
  var src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      className = _ref.className;
  return React.createElement("img", _extends({
    src: src,
    alt: ""
  }, {
    width: width,
    height: height,
    className: className
  }, {
    role: "presentation"
  }));
};

export default DecorativeImage;